export enum ProductKey {
  ms2024 = 'ms2024',
}
